import { classNames } from 'libs/react';
import { TableStackItem } from './TableStackItem';
import { React } from 'libs/react';
import './TableStack.scss';
/**
 * @component TableStack
 * @since 1.0.0
 * @hidden
 */
export function TableStack(props) {
    const { style, ready, schema, values, primaryColumn, actionsColumn } = Object.assign({ ready: true, style: 'normal' }, props);
    const className = classNames('table-stack', 'table-stack--' + style, props.className);
    return (React.createElement("div", { className: className }, values.map((value, index) => (React.createElement(TableStackItem, { key: index, value: value, schema: schema, primaryColumn: primaryColumn, actionsColumn: actionsColumn })))));
}
